<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">LIVE 상세</div>
                    <post-detail-component :postType="'liveDetail'" :postKey="postKey"></post-detail-component>
                    <div class="pa20 text_center">
                        <el-button type="danger" v-if="liveStatus === 1" @click="runClose()">강제종료</el-button>
                        <el-button type="danger" v-else-if="liveStatus === 0" @click="runDelete()">삭제</el-button>
                        <el-button @click="$router.back()">목록</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PostDetailComponent from "@/components/post/PostDetailComponent";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";

export default {
    name: "LiveDetail",
    mixins: [alertMixins],
    components: {
        PostDetailComponent
    },
    provide() {
        return {
            setLiveStatus : this.setLiveStatus,
        }
    },
    props: {},
    data() {
        return {
            postKey: Number(this.$route.params.wr_id),
            liveStatus: null,
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        runDelete() {
            EventBus.$emit('setPostDelete');
        },
        runClose() {
            this.errorAlert('현재 미구현기능입니다.');
        },
        setLiveStatus(status) {
            this.liveStatus = status;
        },
    },
    watch: {},
}
</script>
